import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const HoverIcon = ({ icon }) => {
  return (
    <div className='hover-visible w-100 h-100 flex-column jc-ctr ai-ctr'>
      <FontAwesomeIcon icon={icon} size='2x' />
    </div>
  )
}

export default HoverIcon
